import React, { useContext, useEffect, useState } from "react";
import productImage from "../../assets/images/discount-one.webp";
import useAxios from "../../services/useAxios.tsx";
import AuthenticationContext from "context/Authentication/AuthenticationContext.ts";
import { toast } from "react-hot-toast";

import Container from "components/LogIn/Container";
import { calculateProductPrice } from "../../utils/Helper.ts";
import { removeCommas } from "@persian-tools/persian-tools";
import { isEmpty } from "lodash";

const CardItemContext = React.createContext({
  basketData: "",
  setActiveStep: () => {},
  activeStep: "",
  showOffcanvas: "",
  setShowOffcanvas: () => {},
  changeItemCount: () => {},
  itemCount: 0,
  getItemCountProductPrice: () => {}, //shFazeli 1402/04/26
  submitOrder: () => {}, //shFazeli 1402/04/26
  giftCode: { title: "", value: "-1" },
  setGiftCode: () => {},
});

export default CardItemContext;

const DELIVERY_PRICE = 15000;

export const CardItemContextProvider = ({ children }) => {
  const { execute: getCartItemsApi } = useAxios("api3/get_cart_items"); //shFazeli 1402/04/25 ادرس api عوض شد
  const { execute: addCartItemsApi } = useAxios("api3/add_cartitem"); //shFazeli 1402/04/25
  const { execute: reduceCartItemsApi } = useAxios("api3/delete_cartitem"); //shFazeli 1402/04/25
  const { execute: addOrderApi } = useAxios("api3/add_order"); //shFazeli 1402/04/28
  const { execute: checkGiftCodeApi } = useAxios("api3/check_giftcode");
  const authContext = useContext(AuthenticationContext);
  //دیتای پیشفرض برای سبد خرید
  const [basketData, setBasketData] = useState({
    list: [],
    totalPrice: 0,
    totalDiscount: 0,
    delivery: DELIVERY_PRICE,
  });

  const [giftCode, setGiftCode] = useState({ title: "", value: "-1" });
  const [basketListUpdater, setBasketListUpdater] = useState(false); //shFazeli 1402/04/25
  const [itemCount, setItemCount] = useState(0); //shFazeli 1402/04/25
  const [loginShow, setLoginShow] = useState(false); //shFazeli 1402/04/28
  const [loading, setLoading] = useState(false); //shFazeli 1402/04/28

  /**
   *
   * @param {string add,reduce,remove} type
   */
  const checkGiftCode = (giftCode) => {
    checkGiftCodeApi({ giftCode }).then((res) => {
      switch (res.status) {
        case 1:
          // toast.success("sdf");
          setGiftCode({ value: res.result.value, title: res.result.giftCode });
          break;
        case -2:
          toast.error("کد وارد شده متعلق به این کاربر نیست");
          break;
        case -3:
          toast.error("تاریخ انقضا کد به اتمام رسیده است");
          break;
        case -4:
          toast.error("کد قبلا استفاده شده است");
          break;

        default:
          toast.error("کد نامعتبر است");
          break;
      }
    });
  };

  const changeItemCount = (type, product_price_id) => {
    if (loading) return;
    setLoading(true);
    let payloadObject = { product_price_id: product_price_id, count: 1 };
    if (type == "add") {
      addCartItemsApi(payloadObject).then((res) => {
        if (res.result == 1) {
          setBasketListUpdater((prev) => !prev);
          toast.success("با موفقیت به سبد خرید اضافه گردید");
        } else if (res.msg && !isEmpty(res.msg)) {
          toast.error(res.msg);
        }
        setLoading(false);
      });
    } else if (type == "reduce") {
      reduceCartItemsApi(payloadObject).then((res) => {
        if (res.result == 1) {
          setBasketListUpdater((prev) => !prev);
          toast.success("سبد خرید با موفقیت ویرایش شد");
        } else if (res.msg != "" && res.msg != undefined) {
          toast.error(res.msg);
        }
        setLoading(false);
      });
    } else if (type == "remove") {
      payloadObject = { ...payloadObject, count: 0 };
      reduceCartItemsApi(payloadObject).then((res) => {
        if (res.result == 1) {
          setBasketListUpdater((prev) => !prev);
          toast.success("با موفقیت از سبد حذف گردید");
        } else {
          toast.error("خطا! در ویرایش سبد خرید");
        }
        setLoading(false);
      });
    }
  }; //hosseini 1402/05/12 تغیر نمایش پیام ها از فرانت
  const getCartItems = () => {
    getCartItemsApi().then((res) => {
      //shFazeli 1402/04/25 start
      let shopList = { list: [], totalPrice: 0, totalDiscount: 0 };
      shopList = {
        list: res?.result ?? [],
        totalPrice: res?.result?.reduce((total, num) => {
          let totalProduct = 0;
          if (num.is_available == 1)
            totalProduct = +num?.main_price * +num?.itemcount;

          return total + totalProduct;
        }, 0),
        totalDiscount: res?.result?.reduce((total, product) => {
          let totalProductDiscount = 0;
          if (product.main_discount != "0") {
            totalProductDiscount = removeCommas(
              calculateProductPrice(product, "discount").leftOver
            );
            console.log("discount: ", totalProductDiscount);
          }

          return total + totalProductDiscount;
        }, 0),
        delivery: DELIVERY_PRICE,
      };
      setBasketData(shopList);
      setItemCount(res?.result?.length);
      //shFazeli 1402/04/25 end
    });
  };

  const getItemCountProductPrice = (productPriceId) => {
    let productList = [...basketData.list];
    let productItemCount = productList.filter(
      (v) => v.product_price_id == productPriceId
    );
    if (productItemCount != undefined && productItemCount.length != 0)
      return productItemCount[0]?.itemcount;
    else return 0;
  }; //shFazeli 1402/04/26
  const submitOrder = (data) => {
    let payload = {
      fullname: data.fullname,
      address: data.address,
      postcode: data.zipCode,
      mobile: data.mobile,
      giftCode: giftCode.title,
      delivery_price: DELIVERY_PRICE,
    };

    if (authContext.isLogged)
      addOrderApi(payload).then((result) => {
        if (result?.status == 1) {
          window.location.href = result?.url;
        } else if (result?.msg != "" && result?.ms != undefined)
          toast.error(result.msg);
      });
    else setLoginShow(true);
  };

  useEffect(() => {
    getCartItems();
  }, [basketListUpdater]); //shFazeli 1402/04/25

  const [activeStep, setActiveStep] = useState(1);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  return (
    <CardItemContext.Provider
      value={{
        basketData,
        activeStep,
        showOffcanvas,
        setBasketData,
        setActiveStep,
        setShowOffcanvas,
        giftCode,
        setGiftCode,
        checkGiftCode,
        changeItemCount, //shFazeli 1402/04/25
        itemCount, //shFazeli 1402/04/25
        getItemCountProductPrice, //shFazeli 1402/04/26
        submitOrder, //shFazeli 1402/04/26
      }}
    >
      {children}
      <Container
        loginShow={loginShow}
        setLoginShow={setLoginShow}
        changeUserInformation={() => {}}
      />
      {/* shFazeli 1402/04/28 */}
    </CardItemContext.Provider>
  );
};
